import ContentLoader from 'react-content-loader';

function CartHeaderLoading() {
  return (
    <ContentLoader
      data-testid="cartHeaderLoading"
      speed={2}
      width={375}
      height={87}
      viewBox="0 0 375 87"
      backgroundColor="#fafafa"
      foregroundColor="#ecebeb"
      opacity={0.24}
    >
      <rect x="24" y="26" rx="2" ry="2" width="20" height="20" />
      <rect x="249" y="27" rx="2" ry="2" width="104" height="18" />
      <rect x="96" y="71" rx="8" ry="8" width="16" height="16" />
      <rect x="120" y="71" rx="2" ry="2" width="160" height="16" />
    </ContentLoader>
  );
}

export default CartHeaderLoading;
